import { API_CONFIG } from '../config/api';

interface ApiResponse {
  choices: Array<{
    message: {
      content: string;
    };
  }>;
}

class ApiService {
  private readonly apiKey: string;

  constructor() {
    // In production, this should be loaded from environment variables
    this.apiKey = 'xai-f6C1Q9xlmnL4sbwBpETAtxPdBTwYxXPwHqBGlpiPitcfxp1yDNurOjKZeHzUuZvoXwcCGhNzKSW1vRbA';
  }

  private getHeaders(): HeadersInit {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.apiKey}`
    };
  }

  private async handleResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
      const error = await response.text();
      throw new Error(`API request failed: ${error}`);
    }
    return response.json();
  }

  async generateRecipe(prompt: string): Promise<ApiResponse> {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CHAT}`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({
          messages: [
            {
              role: 'system',
              content: API_CONFIG.SYSTEM_PROMPT
            },
            {
              role: 'user',
              content: prompt
            }
          ],
          model: API_CONFIG.MODEL,
          temperature: API_CONFIG.TEMPERATURE
        })
      });

      return this.handleResponse<ApiResponse>(response);
    } catch (error) {
      console.error('Error generating recipe:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService();